import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "上拉",
  "use": "上拉-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"上拉\"><path d=\"M246.76 686.964l253.604-274.757L753.99 686.964a34.91 34.91 0 1 0 51.316-47.36L526.033 337.06a34.91 34.91 0 0 0-51.316 0L195.444 639.604a34.91 34.91 0 1 0 51.317 47.36\" p-id=\"34690\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol